export type Environment = 'localhost' | 'test' | 'stage' | 'sandbox' | 'production'

interface EnvironmentInfo {
  id: Environment
  name: string | null
  color: string | null
}

const environments: Record<Environment, EnvironmentInfo> = {
  localhost: {
    id: 'localhost',
    name: 'Localhost',
    color: 'orange',
  },
  test: {
    id: 'test',
    name: 'Test',
    color: 'green',
  },
  stage: {
    id: 'stage',
    name: 'Stage',
    color: 'blue',
  },
  sandbox: {
    id: 'sandbox',
    name: 'Sandbox',
    color: 'yellow',
  },
  production: {
    id: 'production',
    name: 'Production',
    color: 'primary',
  },
}

let environmentId: undefined | Environment = undefined
switch (window.location.hostname) {
  case 'app-test.amili.se':
  case 'app-ui-test.amili.se':
    environmentId = 'test'
    break
  case 'app-stage.amili.se':
    environmentId = 'stage'
    break
  case 'app-sandbox.amili.se':
    environmentId = 'sandbox'
    break
  case 'app.amili.se':
  case 'app-ui.amili.se':
    environmentId = 'production'
    break
}
if (/^(localhost|127.0.0.1|\[::1])$/.test(window.location.hostname)) {
  environmentId = 'localhost'
}

function getEnvironment() {
  return environmentId != null ? environments[environmentId] : undefined
}

export default getEnvironment
